module.exports = __webpack_public_path__ + "img/Private Cloud.a081688.svg";